// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608261523/js/" + chunkId + "." + {"44":"38f2a88a","225":"f2569f38","481":"619585a4","486":"d39f70b5","770":"0e804efb"}[chunkId] + ".0.07990555706063007.chunk.js";
};